import React from "react";

// Patterns that indicate AI speech (case-insensitive)
const AI_CONTENT_PATTERNS = [
  /this is \w+ calling from/i,
  /calling from s3 sleep/i,
  /calling on behalf of/i
];

// Format transcript with nice styling for each speaker
const formatTranscript = (transcriptText) => {
  if (!transcriptText) return null;

  // Split by newlines (handle both actual newlines and escaped \n)
  const lines = transcriptText.split(/\\n|\n/).filter(line => line.trim());

  // First pass: detect which speaker is the AI based on content
  let aiSpeakerLabel = null;
  for (const line of lines) {
    const speakerMatch = line.match(/^([a-zA-Z_]+\d*|speaker\d+|agent|customer|ai|patient):\s*/i);
    if (speakerMatch) {
      const content = line.substring(speakerMatch[0].length);
      if (AI_CONTENT_PATTERNS.some(pattern => pattern.test(content))) {
        aiSpeakerLabel = speakerMatch[1].toLowerCase();
        break;
      }
    }
  }

  const getSpeakerInfo = (speakerLabel, content) => {
    // If we identified an AI speaker, use that
    if (aiSpeakerLabel) {
      if (speakerLabel === aiSpeakerLabel) {
        return { displayName: "Agent", isAI: true, isPatient: false };
      } else {
        return { displayName: "Patient", isAI: false, isPatient: true };
      }
    }

    // Fallback: check content on this line
    if (AI_CONTENT_PATTERNS.some(pattern => pattern.test(content))) {
      return { displayName: "Agent", isAI: true, isPatient: false };
    }

    // Unknown - just show the original label cleaned up
    return {
      displayName: speakerLabel.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()),
      isAI: false,
      isPatient: false
    };
  };

  return lines.map((line, index) => {
    // Match any speaker pattern like "speaker_0:", "speaker_1:", "agent:", "customer:", etc.
    const speakerMatch = line.match(/^([a-zA-Z_]+\d*|speaker\d+|agent|customer|ai|patient):\s*/i);

    let speakerInfo = null;
    let displayLine = line;

    if (speakerMatch) {
      const speakerLabel = speakerMatch[1].toLowerCase();
      const content = line.substring(speakerMatch[0].length);
      speakerInfo = getSpeakerInfo(speakerLabel, content);
      displayLine = `${speakerInfo.displayName}: ${content}`;
    }

    const isAI = speakerInfo?.isAI;
    const isPatient = speakerInfo?.isPatient;

    return (
      <div
        key={index}
        style={{
          marginBottom: "12px",
          padding: "8px 12px",
          borderRadius: "8px",
          backgroundColor: isAI ? "#e3f2fd" : isPatient ? "#f5f5f5" : "transparent",
          borderLeft: isAI ? "3px solid #2196f3" : isPatient ? "3px solid #9e9e9e" : "none"
        }}
      >
        <span style={{ fontWeight: speakerInfo ? "600" : "normal" }}>
          {displayLine}
        </span>
      </div>
    );
  });
};

export default formatTranscript;
